module.exports = __webpack_public_path__ + "img/food_drink_qr_code.74bab5fa.png";